export default __webpack_public_path__ + "locales/lv/Article.json?hash=c152a53a0074255287f06f3c98b9e8d0";